export const TIPO_GESTIONE_IMPRESA = {
  DIRETTA: 'Diretta',
  /** DIRETTA_CENTRO_IMPRESE_KIRON: 'Diretta con Centro Imprese Kiron',
  SEGNALAZIONE_CENTRO_IMPRESE_KIRON: 'Segnalazione a Centro Imprese Kiron', */
};

export const STATO_IMPRESA_OPTIONS = {
  Aperta: 'aperta',
  Conclusa: 'chiusa',
  'Chiusa negativa': 'chiusa_negativa',
};

export const TIPO_GESTIONE_IMPRESA_OPTIONS = Object.values(TIPO_GESTIONE_IMPRESA).map((value) => ({
  value,
  key: value,
  label: value,
}));

export const TIPO_GESTIONE_IMPRESA_DROPDOWN_OPTIONS = Object.values(TIPO_GESTIONE_IMPRESA).map((value) => ({
  value,
  key: value,
  text: value,
}));

export const TIPO_OPERAZIONE_IMPRESA_OPTIONS = [
  'Apertura di credito in conto corrente',
  'Crediti di firma',
  'Factoring',
  'Finanziamento a medio-lungo',
  'Finanziamento a tasso agevolato',
  'Finanziamento per anticipo su crediti e documenti e sconto portafoglio commerciale',
  'Leasing',
  'Mutuo Chirografario',
  'Mutuo ipotecario/mutuo fondiario',
  'Altro',
].map((value) => ({
  value,
  key: value,
  label: value,
}));

export const TIPO_OPERAZIONE_IMPRESA_DROPDOWN_OPTIONS = TIPO_OPERAZIONE_IMPRESA_OPTIONS.map(({ value, key }) => ({
  value,
  key,
  text: value,
}));

export const STATO_IMPRESA_DROPDOWN_OPTIONS = Object.entries(STATO_IMPRESA_OPTIONS).map(([key, value]) => ({
  value,
  key: value,
  text: key,
}));



// WEBPACK FOOTER //
// ./app/shared/constants/processoImprese.js